import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DropdownSettingsStateService {
  private _isDropdownSettingsPageOpen = signal(false);
  public isDropdownSettingsPageOpen = this._isDropdownSettingsPageOpen.asReadonly();

  public dropdownSettingsPageOpen() {
    this._isDropdownSettingsPageOpen.set(true);
  }

  public dropdownSettingsPageClose() {
    this._isDropdownSettingsPageOpen.set(false);
  }
}
